import { gql } from 'apollo-angular';

export const CopyFunnelContentDocument = gql`
  mutation copyFunnelContent($destinationFunnelId: Int!, $funnelToCopyId: Int!) {
    copyFunnelContent(destinationFunnelId: $destinationFunnelId, funnelToCopyId: $funnelToCopyId) {
      id
    }
  }
`;
